// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__K7h39","label":"Category_label__1ZUlz","content":"Category_content__1DVjy","header":"Category_header__3kdNL","location":"Category_location__2Y2gE"};